// extracted by mini-css-extract-plugin
module.exports =  {"leftMargin":"a8th3T_e"};